import React from 'react'
import { SvgIcon } from '../svg-icon'

/**
 * Define default props as fallback. See SvgIcon base class for propTypes.
 *
 * @static
 * @type {React.defaultProps}
 */
const defaultProps = {
    viewBoxSize: 48
}

const path = `m19.91,41.27v-5.96l-7.17-7.88v-10.86c0-.84.29-1.56.86-2.15.57-.59,1.26-.88,2.07-.88l3.03,
    3.03h-2.93v9.65l7.17,7.86v4.16h3.84v-4.14l2.47-2.73L4,6.12l2.12-2.12,37.88,37.88-2.12,2.12-10.45-10.45-1.62,
    1.77v5.96h-9.9Zm15.66-12.12l-1.62-1.62v-10.96h-10.96l-5.1-5.1v-6.57h3.03v8.64h7.88V4.91h3.03v10.15l-1.52-1.52h3.64c.83,
    0,1.55.3,2.14.89s.89,1.31.89,2.14v10.96l-1.41,1.62Z`

/**
 * Stateless function representing a missing ISO cable icon.
 *
 * @function
 * @param {Object} [props] The component properties
 * @returns {ReactElement} React component markup
 *
 * @see SvgIcon
 * @example
 * <MissingIsoCableIcon width={48} />
 */
const MissingIsoCableIcon = props => (
    <SvgIcon {...props}>
        <path d={path} />
    </SvgIcon>
)

MissingIsoCableIcon.defaultProps = defaultProps

export { MissingIsoCableIcon }
